"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigResponseToJSON = exports.ConfigResponseFromJSONTyped = exports.ConfigResponseFromJSON = void 0;
function ConfigResponseFromJSON(json) {
    return ConfigResponseFromJSONTyped(json, false);
}
exports.ConfigResponseFromJSON = ConfigResponseFromJSON;
function ConfigResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'distanceDeliveryMax': json['distanceDeliveryMax'],
        'distancePickupMax': json['distancePickupMax'],
    };
}
exports.ConfigResponseFromJSONTyped = ConfigResponseFromJSONTyped;
function ConfigResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'distanceDeliveryMax': value.distanceDeliveryMax,
        'distancePickupMax': value.distancePickupMax,
    };
}
exports.ConfigResponseToJSON = ConfigResponseToJSON;
